import React, { FC } from 'react';
import { IHandledDocument } from '../../types';
import ResultItem from '../ResultItem';
import { DocumentNamePosition } from '../ResultItem/types';

export interface ISearchResultsByDocumentsProps {
  documents: IHandledDocument[];
}

export const SearchResultsByDocuments: FC<ISearchResultsByDocumentsProps> = props => {
  const { documents } = props;
  return (
    <>
      {documents.map(document => (
        <ResultItem
          document={document}
          key={document.filePath}
          namePosition={DocumentNamePosition.DocumentNode}
          mainSearchProfile={null}
        />
      ))}
    </>
  );
};

export default SearchResultsByDocuments;
